import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Check, ArrowRight } from 'lucide-react';
export function SolutionReveal() {
  return <section className="w-full px-6 py-16 md:py-20 bg-charcoal text-linen overflow-hidden" data-id="element-183">
      <div className="max-w-6xl mx-auto" data-id="element-184">
        {/* Intro */}
        <div className="text-center mb-16 relative" data-id="element-185">
          <FadeIn data-id="element-186">
            <p className="text-gold font-bold tracking-[0.3em] uppercase mb-6 text-xs" data-id="element-187">
              Presentando
            </p>
            <h2 className="text-5xl md:text-7xl lg:text-8xl mb-8 text-white font-serif tracking-tight" data-id="element-188">
              BARRIGA REBELDE
            </h2>
            <p className="text-xl md:text-2xl text-linen/70 max-w-2xl mx-auto font-light leading-relaxed" data-id="element-189">
              Mini Guía Anti‑Inflamación y Anti‑Antojos <br data-id="element-190" />
              <span className="text-rose-light italic font-serif" data-id="element-191">
                (Sin Dieta Perfecta)
              </span>
            </p>
          </FadeIn>
        </div>

        {/* What it is */}
        <div className="grid md:grid-cols-2 gap-8 mb-20 max-w-5xl mx-auto" data-id="element-192">
          <FadeIn delay={0.1} data-id="element-193">
            <div className="bg-white/5 backdrop-blur-sm p-10 border border-white/10 h-full hover:border-gold/30 transition-colors duration-500" data-id="element-194">
              <h3 className="text-3xl font-serif text-white mb-6 italic" data-id="element-195">
                Objetivo (21 días)
              </h3>
              <p className="text-linen/80 leading-relaxed font-light text-lg" data-id="element-196">
                Sentirte más liviana en tu ropa, bajar distensión diaria y
                recuperar control de la noche… sin entrar en modo obsesión.
              </p>
            </div>
          </FadeIn>
          <FadeIn delay={0.2} data-id="element-197">
            <div className="bg-white/5 backdrop-blur-sm p-10 border border-white/10 h-full hover:border-gold/30 transition-colors duration-500" data-id="element-198">
              <h3 className="text-3xl font-serif text-white mb-6 italic" data-id="element-199">
                Para mujeres que:
              </h3>
              <ul className="space-y-4" data-id="element-200">
                {['Se sienten hinchadas casi todos los días', 'Tienen antojos fuertes en la tarde/noche', 'Quieren estructura, pero no quieren vivir a dieta', 'Necesitan algo que funcione con micro/airfryer'].map((item, i) => <li key={i} className="flex items-start gap-4 text-linen/80 font-light" data-id="element-201">
                    <Check className="w-5 h-5 text-gold mt-0.5 shrink-0" data-id="element-202" />
                    <span data-id="element-203">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>

        {/* The Mechanism */}
        <div className="bg-linen text-charcoal p-12 md:p-20 relative" data-id="element-204">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-gold/0 via-gold/50 to-gold/0" data-id="element-205"></div>

          <FadeIn data-id="element-206">
            <div className="text-center mb-14" data-id="element-207">
              <h3 className="text-4xl md:text-5xl mb-6 font-serif" data-id="element-208">
                La solución: la Regla 3‑2‑1
              </h3>
              <div className="h-px w-24 bg-charcoal/10 mx-auto mb-6" data-id="element-209"></div>
              <p className="text-lg text-body max-w-2xl mx-auto font-light" data-id="element-210">
                Este es el núcleo del método. Simple, repetible, y diseñado para
                proteger tu noche.
              </p>
            </div>

            <div className="grid md:grid-cols-3 gap-12 relative z-10" data-id="element-211">
              {[{
              num: '3',
              title: 'Anclas de proteína',
              desc: 'Tres momentos donde tu cuerpo entiende: "hay base".'
            }, {
              num: '2',
              title: 'Ventanas de carbo',
              desc: 'No eliminas carbs. Los pones donde te convienen para que no te ataquen después.'
            }, {
              num: '1',
              title: 'Ritual post‑cena',
              desc: 'Una rutina de 12-15 min para "cerrar cocina" y apagar el circuito antojo.'
            }].map((item, i) => <div key={i} className="text-center flex flex-col items-center" data-id="element-212">
                  <span className="font-serif text-8xl md:text-9xl leading-none font-bold text-charcoal/8 select-none mb-2" data-id="element-213">
                    {item.num}
                  </span>
                  <h4 className="text-2xl font-serif font-bold mb-4 text-charcoal" data-id="element-214">
                    {item.title}
                  </h4>
                  <p className="text-body font-light leading-relaxed" data-id="element-215">
                    {item.desc}
                  </p>
                </div>)}
            </div>

            <div className="text-center mt-14 pt-8 border-t border-charcoal/10" data-id="element-216">
              <p className="font-serif text-3xl italic text-rose" data-id="element-217">
                "No es volverte perfecta. Es volverte estable."
              </p>

              <a href="#precio" className="inline-flex items-center gap-3 mt-10 bg-rose hover:bg-rose-light text-white font-medium text-sm tracking-[0.2em] uppercase px-10 py-5 transition-all duration-300 shadow-xl shadow-rose/10 hover:shadow-rose/20 rounded-none no-underline" data-id="element-218">
                La quiero
                <ArrowRight className="w-4 h-4" data-id="element-219" />
              </a>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}